import request from './base'
// const baseUrl = '/openapi'
let nodeEnv = process.env.NODE_ENV
const baseUrl = nodeEnv === 'development' ? '/openapi' : `https://openapi.youbaolian.cn/api`

const openapi = '/open'
export default {
  dataCommit: (commit, data, mutation) => {
    return request.pureDataCommit(commit, data, mutation)
  },
  // 省
  getProvince: (commit, payload, mutation) => {
    let options = request.getOptions('/preprice-car/natgeos/province', payload, null, baseUrl)
    return request.get(commit, options, mutation)
  },
  // 市
  getCity: (commit, payload, mutation) => {
    let options = request.getOptions(`/preprice-car/natgeos/city/${payload.id || payload}`, {}, null, baseUrl)
    return request.get(commit, options, mutation)
  },
  // 区
  getDistrict: (commit, payload, mutation) => {
    let options = request.getOptions(`/preprice-car/natgeos/district/${payload.id || payload}`, {}, null, baseUrl)
    return request.get(commit, options, mutation)
  },
  /**
   * 银行卡信息
   * params: {
   *  CardNo：'6217857600048704253',
   *  PartnerId: 10000,
   *  CustomerId: 1
   * }
   */
  getBankInfoByBankAccount: (commit, playload, mutation) => {
    let options = request.getOptions('/payment?action=GetBankCardAttr', playload, null, openapi)
    return request.post(commit, options, mutation)
  },
  /**
   * 支行
   * params: {
   *  BankName: '',
   *  BankCode: '',
   *  PartnerId: 10000
   * }
   */
  getBatchBankInfoByCode: (commit, playload, mutation) => {
    let options = request.getOptions('/payment?action=GetAccountBank', playload, null, openapi)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/common.js